import { type Static, Type } from '@sinclair/typebox';
import { CommentDTOSchema } from '../dto/comment.dto.js';
import { MongoIdStringSchema, PaginateDTOSchema } from '../dto/common.dto.js';

export const ListCommentsParamsSchema = Type.Object({ page: Type.Number() });
export type ListCommentsParam = Static<typeof ListCommentsParamsSchema>;

export const ListCommentsQuerystringSchema = Type.Object({ itemId: MongoIdStringSchema });
export type ListCommentsQuerystring = Static<typeof ListCommentsQuerystringSchema>;

export const ListCommentsReplySchema = PaginateDTOSchema(CommentDTOSchema);
export type ListCommentsReply = Static<typeof ListCommentsReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const ListCommentRepliesParamsSchema = Type.Object({ commentId: MongoIdStringSchema, page: Type.Number() });
export type ListCommentRepliesParams = Static<typeof ListCommentRepliesParamsSchema>;

export const ListCommentRepliesReplySchema = PaginateDTOSchema(CommentDTOSchema);
export type ListCommentRepliesReply = Static<typeof ListCommentRepliesReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const CreateCommentBodySchema = Type.Object({
  content: Type.String({ maxLength: 5000 }),
  itemId: Type.Optional(MongoIdStringSchema),
  parentCommentId: Type.Optional(MongoIdStringSchema),
});
export type CreateCommentBody = Static<typeof CreateCommentBodySchema>;

export const CreateCommentReplySchema = CommentDTOSchema;
export type CreateCommentReply = Static<typeof CreateCommentReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const DeleteCommentParamsSchema = Type.Object({ commentId: MongoIdStringSchema });
export type DeleteCommentParams = Static<typeof DeleteCommentParamsSchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const LikeCommentParamsSchema = Type.Object({ commentId: MongoIdStringSchema });
export type LikeCommentParams = Static<typeof LikeCommentParamsSchema>;

export const LikeCommentReplySchema = CommentDTOSchema;
export type LikeCommentReply = Static<typeof LikeCommentReplySchema>;
